export default "__VITE_ASSET__CY$o8f2x__"